import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initialized: false,
  gunguMainIndex: {},
  gunguMainIndexInit: false,

  sidoMainIndex: {},
  sidoMainIndexInitialized: false,
  sidoPriceIndex: {},
  sidoPriceIndexInitialized: false,
  sidoPriceIndexConditionGroup: {},
  sidoPriceIndexConditionGroupInitialized: false,
  sidoMarketIndexConditionGroup: {},
  sidoMarketIndexConditionGroupInitialized: false,
  sidoGunguPriceIndexChangedRateWeekly: {},
  sidoGunguPriceIndexChangedRateWeeklyInitialized: false,
  sidoGunguPriceIndexChangedRateMonthly: {},
  sidoGunguPriceIndexChangedRateMonthlyInitialized: false,

  sidoPriceIndexChangedRate: {},
  sidoPriceIndexChangedRateInitialized: false,
};

const reducers = {
  getGunguMainIndex(state, action) {
    const payload = action.payload;
    state.gunguMainIndex = payload;
    state.gunguMainIndexInit = true;
  },
  getSidoMainIndex(state, action) {
    const payload = action.payload;
    state.sidoMainIndex = payload;
    state.sidoMainIndexInitialized = true;
  },
  getSidoPriceIndex(state, action) {
    const payload = action.payload;
    state.sidoPriceIndex = payload;
    state.sidoPriceIndexInitialized = true;
  },
  getSidoPriceIndexConditionGroup(state, action) {
    const payload = action.payload;
    state.sidoPriceIndexConditionGroup = payload;
    state.sidoPriceIndexConditionGroupInitialized = true;
  },
  getSidoMarketIndexConditionGroup(state, action) {
    const payload = action.payload;
    state.sidoMarketIndexConditionGroup = payload;
    state.sidoMarketIndexConditionGroupInitialized = true;
  },
  getSidoGunguPriceIndexChangedRateWeekly(state, action) {
    const payload = action.payload;
    state.sidoGunguPriceIndexChangedRateWeekly = payload;
    state.sidoGunguPriceIndexChangedRateWeeklyInitialized = true;
  },
  getSidoGunguPriceIndexChangedRateMonthly(state, action) {
    const payload = action.payload;
    state.sidoGunguPriceIndexChangedRateMonthly = payload;
    state.sidoGunguPriceIndexChangedRateMonthlyInitialized = true;
  },
  getSidoPriceIndexChangedRate(state, action) {
    const payload = action.payload;
    state.sidoPriceIndexChangedRate = payload;
    state.sidoPriceIndexChangedRateInitialized = true;
  },
  getSidoConditions(state, action) {
    const payload = action.payload;
    state.initialized = true;
    state.sidoPriceIndexConditionGroup = payload.priceIndex;
    state.sidoPriceIndexConditionGroupInitialized = true;
    state.sidoMarketIndexConditionGroup = payload.marketIndex;
    state.sidoMarketIndexConditionGroupInitialized = true;
    state.sidoGunguPriceIndexChangedRate = payload.priceIndexChangedRate;
    state.sidoGunguPriceIndexChangedRateInitialized = true;
  },
};

export const slice = createSlice({
  name: "condition",
  initialState,
  reducers,
});

export const { reducer } = slice;
